module.exports = __webpack_public_path__ + "img/BCCA_logo_pos.d74fa31b.png";